import SMConst from 'lib/SMConst';
import SMPlanHelper from './SMPlanHelper';

class SMRoomHelper {
  static isAllowedRentType(room, rentType){
    if (room == undefined) return false;
    if (room.allow_rent_types == undefined) return false;
    return room.allow_rent_types.some(function(e) { return e == rentType; });
  }

  static isRequireOptionFood(room) {
    if (SMPlanHelper.isRequireOptionFood(room)) return true;
    if (room.plans.length == 0) return false;

    return room.plans.some((plan)=>{
      return (SMPlanHelper.isRequireOptionFood(plan));
    });
  }

  static isRequiredReview(room) {
    if (room == undefined) return false;
    return (room.stay_certification_status != SMConst.StayCertificationStatus.Activated);
  }

  static isIncludeStayPlan(room) {
    if (room.rent_type === SMConst.RentType.Stay) return true;
    if (room.plans == undefined) return false;
    return room.plans.some((plan)=>{
      return plan.rent_type === SMConst.RentType.Stay;
    });
  }
}
export default SMRoomHelper;


// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMRoomHelper.js